module.exports = __webpack_public_path__ + "static/media/folder.16f4c7e3.svg";